import { FunctionComponent } from 'react';
import { IonButton, IonContent, IonItem, IonList, IonPopover } from '@ionic/react';
import './filter.component.scss';
import filterIcon from '../../../icons/filter.svg';

export interface FilterComponentProps {
  title: string,
  buttonTitle: string,
  options: { value: string, label: string, key: number }[]
  onSelectionChanged: (value: string) => void,
  buttonStyle?: React.CSSProperties
}

export const FilterComponent: FunctionComponent<FilterComponentProps> = (
  { title, buttonTitle, options, onSelectionChanged, buttonStyle }
) => {

  return (<div className={ 'filter' }>
      <div>{ title }</div>
      <IonButton id="popover-button" style={buttonStyle}>
        <img src={filterIcon} alt="filter" style={{ marginRight: '4px', width: '16px', height: '16px' }} />
        { buttonTitle }
      </IonButton>
      <IonPopover trigger="popover-button" dismissOnSelect={ true }>
        <IonContent>
          <IonList>
            { options.map((option) =>
              <IonItem
                button={ true }
                detail={ false }
                onClick={ () => onSelectionChanged(option.value) }
                key={ option.key }
                style={ { margin: '0 8px' } }
              >
                { option.label }
              </IonItem>
            ) }
          </IonList>
        </IonContent>
      </IonPopover>
    </div>
  );
};



